import { restClient } from 'api/rest-client';
import { AUTH_REFRESH_URI } from 'shared/consts/config';
import { toast } from 'shared/hooks/useToast';

export const refreshAuth = () => {
  toast({ title: 'Your authentication have expired. Attempting to refresh access token...', variant: 'loading' });
  return restClient.post<void>(AUTH_REFRESH_URI);
};
